import React, { useState, useEffect, useRef } from "react";
import "./domain.css";

import Logistics1 from "../Assets/logistics1.png";
import Box1 from "../Assets/logi-box1.png";
import Box2 from "../Assets/logi-box2.png";
import Box3 from "../Assets/logi-box3.png";
import Box4 from "../Assets/logi-box4.png";
import Box5 from "../Assets/logi-box5.png";

import { useStateContext } from "../contexts/ContextProvider";
import DomainBanner from "./DomainBanner";

const Logistics = () => {
  const title = "Logistics";
  const body =
    "In the dynamic world of retail, where customer preferences evolve rapidly and competition is fierce, empowering your team with the right skills is essential for success. Our tailored digital upskilling solutions meet the unique demands of transportation and logistics, ensuring excellence and compliance. From product knowledge to customer service, we equip your team for success.";

  const { handleShowContact } = useStateContext();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional, for animated scrolling
    });
  }, []);
  return (
    <>
      <DomainBanner domain="logistics" title={title} body={body} />
      <div className="domain-section">
        <div className="domain-container domain-text">
          <h3>Challenges</h3>
          <ul>
            <li>
              Compliance and Safety: Logistics operations entail handling
              hazardous materials and navigating complex regulations. Training
              on safety protocols and regulatory compliance is crucial to ensure
              a safe working environment.
            </li>
            <li>
              Efficient Operations: Logistics companies strive to optimize
              efficiency, reduce transit times, and minimize costs. Training on
              lean principles and inventory management helps streamline
              processes and improve overall efficiency
            </li>
            <li>
              Technology Integration: The logistics industry adopts advanced
              technologies like GPS tracking and route optimization software.
              Training on these technologies enables employees to leverage them
              effectively, enhancing operational performance.
            </li>
            <li>
              Driver Training and Compliance: Ensuring driver safety and
              regulatory compliance is vital for transportation companies.
              Training programs cover defensive driving, hours-of-service
              regulations, and vehicle inspection procedures to minimize
              accidents and violations.
            </li>
            <li>
              Data Security and Cybersecurity: With increased digitization,
              protecting sensitive data and preventing cyber threats is
              paramount. Training on cybersecurity best practices educates
              employees on maintaining data security and recognizing potential
              threats.
            </li>
          </ul>
        </div>
      </div>

      <div className="domain-section">
        <div className="domain-container">
          <div className="heading-flex text-center">
            <h3>Why Choose Our e-Training Solutions ?</h3>
          </div>
          <div className="domain-features logistics">
            <div className="row mb-5">
              <div className="col-lg-6 col-md-6">
                <div className="box-new2">
                  <div className="box-cover">
                    <div className="img">
                      <img src={Box1} className="img-fluid" alt="" />
                    </div>
                    <div className="content">
                      <h3>Anytime, Anywhere Learning</h3>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="box-new2">
                  <div className="box-cover">
                    <div className="img">
                      <img src={Box2} className="img-fluid" alt="" />
                    </div>
                    <div className="content">
                      <h3>Cost-Effective Solutions</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mb-5">
              <div className="col-lg-12 d-flex align-items-center justify-content-center">
                <div className="box-new2">
                  <div className="box-cover">
                    <div className="img">
                      <img src={Box3} className="img-fluid" alt="" />
                    </div>
                    <div className="content">
                      <h3>Tailored to Industry Needs</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="box-new2">
                  <div className="box-cover">
                    <div className="img">
                      <img src={Box4} className="img-fluid" alt="" />
                    </div>
                    <div className="content">
                      <h3>Stay Current with Regulations</h3>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="box-new2">
                  <div className="box-cover">
                    <div className="img">
                      <img src={Box5} className="img-fluid" alt="" />
                    </div>
                    <div className="content">
                      <h3>Language Barrier? Not a Problem</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="domain-section">
        <div className="domain-container">
          <div className="domain-bg domain-bg2">
            <h3>Ready to Elevate Your Team's Performance?</h3>
            <p>
              Empower your team with the knowledge and skills they need to
              thrive in the fast-paced world of transportation and logistics.
              Our eTraining solutions offer unmatched flexibility,
              customization, and cost-effectiveness, helping your business stay
              ahead of the curve while prioritizing safety and compliance.
            </p>
          </div>
        </div>
      </div>
      <div className="domain-section">
        <div className="domain-container">
          <p className="domain-text3">
            Learn more about our eTraining solutions and how they can benefit
            your business.
          </p>
        </div>
      </div>
      <div className="cta">
        <div className="cta-flex" onClick={handleShowContact}>
          <h4>Let's Get In Touch</h4>
          <svg
            width="46"
            height="47"
            viewBox="0 0 46 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.417 33.0834L32.5837 13.9167M32.5837 13.9167H15.3337M32.5837 13.9167V31.1668"
              stroke="#15ADAA"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </>
  );
};

export default Logistics;
